export const LAUNCHER_URL = 'https://launcherqa.enquirybot.com/'
export const WIDGET_URL = 'https://widgetqa.enquirybot.com/#/'
export const SOCKET_URL = 'https://chatqa.enquirybot.com'
export const IOS_SOCKET_URL = 'https://chatqa.enquirybot.com'
export const API_BASE_URL = 'https://codeqa.enquirybot.com'
export const POWEREDBY_URL = 'https://enquirybot.com/whoops'
export const BOT_IMAGE_URL = 'https://screenshots-demo-eb.s3-eu-west-1.amazonaws.com/botimage.svg'
export const MATERIAL_ICON_URL = 'https://fonts.googleapis.com/icon?family=Material+Icons'
// export const LAUNCHER_URL = 'http://localhost:9000/'
// export const WIDGET_URL = 'http://localhost:5000/#/'
// export const SOCKET_URL = 'http://localhost:4000'
// export const IOS_SOCKET_URL = 'http://localhost:4000'
// export const API_BASE_URL = 'http://localhost:8000'
